/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: NonNullable<unknown> }} Valve_Body_SeizedInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "Th. head body seized up" |
* | "true" | "Th. head body seized up since {date}" |
* | * | "Th. head body seized up" |
*
* @param {Valve_Body_SeizedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_body_seized = /** @type {((inputs: Valve_Body_SeizedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Body_SeizedInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Th. head body seized up`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Th. head body seized up since ${i?.date}`);
		return /** @type {LocalizedString} */ (`Th. head body seized up`)
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Le corps de vanne est grippé`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Le corps de vanne est grippé depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ (`Le corps de vanne est grippé`)
	}
});